import { Component, Inject } from '@angular/core';
import { NEW_MODAL_DATA, NewModalRef } from 'outshared-lib';

@Component({
    selector: 'ins-add-party-modal',
    templateUrl: './add-party-modal.component.html',
    styleUrls: ['./add-party-modal.component.scss']
})
export class AddPartyModalComponent {

    constructor(private modalRef: NewModalRef<AddPartyModalComponent>, @Inject(NEW_MODAL_DATA) public data: any) { }

    public onCancel(): void {
        this.modalRef.close();
    }
}
